var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],ref:"watermark",staticClass:"global-watermark"})
}
var staticRenderFns = []

export { render, staticRenderFns }